import { makeObservable, observable, action } from 'mobx';
import PartnerPageApi from '../api/partnerPageApi';

class RootStore {
  partnerPage = {};

  setPartnerPage = (value) => {
    this.partnerPage = value;
  }

  init = async (systemName, query) => {
    const response = await PartnerPageApi.getPartnerPage(systemName, query);
    this.setPartnerPage(response);
  };

  constructor() {
    makeObservable(this, {
      partnerPage: observable,
      setPartnerPage: action,
    });
  }
}

export default RootStore;
